import { useMemo, useState } from "react";
import { VaultItem } from "../types";

export const useVaultSearch = (vaults: VaultItem[]) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredVaults = useMemo(() => {
    if (!searchQuery.trim()) return vaults;

    const query = searchQuery.toLowerCase();
    return vaults.filter(
      (vault) =>
        vault.title.toLowerCase().includes(query) ||
        vault.description.toLowerCase().includes(query)
    );
  }, [searchQuery, vaults]);

  const coreVaults = useMemo(
    () => filteredVaults.filter((vault) => vault.category === "core"),
    [filteredVaults]
  );

  const partnerVaults = useMemo(
    () => filteredVaults.filter((vault) => vault.category === "partner"),
    [filteredVaults]
  );

  return {
    searchQuery,
    setSearchQuery,
    filteredVaults,
    coreVaults,
    partnerVaults,
  };
};
